// extracted by mini-css-extract-plugin
module.exports = {"title":"Faq_title__1FMI3","nav":"Faq_nav__3FRCM","btn":"Faq_btn__23t7F","active":"Faq_active__b861P","dropdown":"Faq_dropdown__36fWV","list":"Faq_list__np2PI"};